<template>
  <div class="columns">
    <div class="column is-three-quarters solicitudes-table">
      <admin-section-header icon="arrow-up" :title="$t('Mis solicitudes')" />

      <div class="field has-addons">
        <div class="control">
          <a @click="goToNewRequest()" class="button is-primary is-medium">
            {{ $t('Nueva solicitud') }}
          </a>
        </div>
      </div>

      <b-table
        class="section full-height "
        :loading="isLoading"
        :paginated="true"
        :per-page="10"
        :striped="true"
        :hoverable="true"
        default-sort="name"
        :data="myNeofintechRequests"
      >
        <template slot-scope="props">
          <b-table-column :label="$t('Creada')" field="createdAt" sortable>{{
            props.row.createdAt | formatTimestamp
          }}</b-table-column>
          <b-table-column
            :label="$t('Actualizada')"
            field="updatedAt"
            sortable
            >{{ props.row.updatedAt | formatTimestamp }}</b-table-column
          >
          <b-table-column label="Fase" field="phase" sortable>{{
            props.row.phase
          }}</b-table-column>
          <b-table-column label="Estado" field="status" sortable>{{
            $t(props.row.status)
          }}</b-table-column>
          <b-table-column label=" ">
            <div class="buttons is-right">
              <button
                @click="goToRequestDetail(props.row.GSI1SK)"
                class="button is-small is-primary"
                type="button"
              >
                <b-icon icon="eye" custom-size="default" />
              </button>
            </div>
          </b-table-column>
        </template>

        <section class="section" slot="empty">
          <div class="content has-text-grey has-text-centered">
            <template v-if="isLoading">
              <p>
                <b-icon icon="dots-horizontal" size="is-large" />
              </p>
              <p>{{ $t('Cargando') }}...</p>
            </template>
            <template v-else>
              <p>
                <b-icon icon="emoticon-sad" size="is-large" />
              </p>
              <p>{{ $t('No hay resultados') }}&hellip;</p>
            </template>
          </div>
        </section>
      </b-table>
    </div>
    <div class="column is-one-quarter twitter">
      <TwitterFeed profile="bopinion" />
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import Fetcher from '@/mixins/fetcher.js'
import AdminSectionHeader from '@/components/admin/dasboard/AdminSectionHeader.vue'
import TwitterFeed from '@/components/admin/dasboard/TwitterFeed.vue'

export default {
  mixins: [Fetcher],
  props: ['id'],
  components: { TwitterFeed, AdminSectionHeader },
  mounted() {
    this.getMyNeofintechRequests()
  },
  data() {
    return {
      myNeofintechRequests: []
    }
  },
  methods: {
    ...mapActions('onBoard', ['getOnboardRequests']),
    goToRequestDetail(id) {
      this.$router.push({
        name: 'onBoard.neofintech.myNeofintechRequestDetail',
        params: { id: id }
      })
    },
    goToNewRequest() {
      this.$router.push({
        name: 'onBoard.neofintech.phase1.1'
      })
  
    },
    getMyNeofintechRequests: function() {
      let self = this
      self.request(() =>
        self.getOnboardRequests().then(function(response) {
          self.myNeofintechRequests = response.data
        })
      )
    }
  }
}
</script>

<style scoped>
.columns {
  margin-top: 0;
  overflow: hidden;
}
.column.twitter,
.solicitudes-table {
  overflow: scroll;
}
</style>
